import { FlexRowBetween, LoaderBar, ScreenHeader } from 'components'
import {
  CreatorGenreSections,
  // LiveRoundLeaderboardSections,
  LiveRoundSections,
  TopCreatorsSections,
  TrendingVideosSections,
} from 'page-components'
import { Button } from 'antd'
import { CalendarOutlined } from '@ant-design/icons'
import styled from 'styled-components'
import React from 'react'
import { useGetDashboardData } from 'hooks'
import { useAuth } from 'context'

export const HeaderWrapper = styled.div`
  display: flex;
  padding: 6px 40px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

const FilterButton = styled(Button)`
  display: flex;
  padding: 14px 10px;
  align-items: center;
  gap: 8px;
  font-weight: bold;
  font-size: 14px;
`
export const DashBoardScreen = () => {
  const { user } = useAuth()
  const { data, loading } = user?.accessToken
  ? useGetDashboardData()
    : { loading: true }
  return (
    <div>
      <HeaderWrapper>
        <ScreenHeader text="Analytics" />
        <FilterButton icon={<CalendarOutlined />}>This Week</FilterButton>
      </HeaderWrapper>
      {loading && <LoaderBar />}
      {!loading && (
        <div className="px-5">
          <LiveRoundSections data={data?.liveRoundData?.data || {}} />
          <FlexRowBetween className="d-flex align-items-stretch w-100">
            <div className="col-5 px-2 d-flex flex-column">
              <TrendingVideosSections data={data?.trendingVideo || []} />
            </div>
            <div className="col-7 px-2 d-flex flex-column">
              <CreatorGenreSections data={data?.genreData || []} />
            </div>
          </FlexRowBetween>
          <FlexRowBetween className="align-items-start">
            {/* <div className="col-6 px-2">
              <LiveRoundLeaderboardSections />
            </div> */}
            <div className="col-6 px-2">
              <TopCreatorsSections data={data?.topCreatorList || []} />
            </div>
          </FlexRowBetween>
        </div>
      )}
    </div>
  )
}
